export const GET_ALL_COUNTRY = "GET_ALL_COUNTRY";
export const GET_COUNTRY = "GET_COUNTRY";
export const LOADING_ALL_COUNTRY = "LOADING_ALL_COUNTRY";

export const GET_BY_ID_PROVINCE = "GET_BY_ID_PROVINCE";
export const GET_BY_COUNTRY = "GET_BY_COUNTRY";
export const LOADING_BY_COUNTRY = "LOADING_BY_COUNTRY";